import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CreateSignalRequest, CreateSignalResponse } from "./types";
import { getSignalsQueryKeyPrefix } from "./useGetSignals";

import { ENDPOINTS } from "@/api/application-api";
import { ToastType } from "@/enums";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast, displayToast } from "@/utils/toast";

interface CreateSignalParams extends CreateSignalRequest {
  workspaceId: number;
  userToken: string;
}

export const useCreateSignal = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      workspaceId,
      userToken,
      ...payload
    }: CreateSignalParams): Promise<CreateSignalResponse> => {
      const response = await fetch(ENDPOINTS.signals.create(workspaceId), {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(payload),
      });

      return handleResponse(response);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: getSignalsQueryKeyPrefix(variables.workspaceId),
      });
      displayToast("Signal created", ToastType.success);
    },
    onError: (error: Error) => {
      displayErrorToast(error.message);
    },
  });
};
